var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cs-text-editor"},[(_vm.editor)?_c('div',{staticClass:"text-editor-menu"},[_c('button',{class:{ 'is-active': _vm.editor.isActive('paragraph') },attrs:{"type":"button","title":"Paragraph"},on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .setParagraph()
          .run()}}},[_c('icon',{attrs:{"name":"paragraph"}})],1),_c('button',{class:{ 'is-active': _vm.editor.isActive('bold') },attrs:{"type":"button","title":"Bold"},on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .toggleBold()
          .run()}}},[_c('icon',{attrs:{"name":"bold"}})],1),_c('button',{class:{ 'is-active': _vm.editor.isActive('italic') },attrs:{"type":"button","title":"Italic"},on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .toggleItalic()
          .run()}}},[_c('icon',{attrs:{"name":"italic"}})],1),_c('button',{class:{ 'is-active': _vm.editor.isActive('strike') },attrs:{"type":"button","title":"Strike-through"},on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .toggleStrike()
          .run()}}},[_c('icon',{attrs:{"name":"strikethrough"}})],1),_c('button',{class:{ 'is-active': _vm.editor.isActive('bulletList') },attrs:{"type":"button","title":"Unordered List"},on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .toggleBulletList()
          .run()}}},[_c('icon',{attrs:{"name":"ul"}})],1),_c('button',{class:{ 'is-active': _vm.editor.isActive('link') },attrs:{"type":"button","title":"Link"},on:{"click":_vm.setLink}},[_c('icon',{attrs:{"name":"link"}})],1),_c('button',{class:{ 'is-active': _vm.editor.isActive('heading', { level: 1 }) },attrs:{"type":"button","title":"Heading 1"},on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .toggleHeading({ level: 1 })
          .run()}}},[_c('icon',{attrs:{"name":"h1"}})],1),_c('button',{class:{ 'is-active': _vm.editor.isActive('heading', { level: 2 }) },attrs:{"type":"button","title":"Heading 2"},on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .toggleHeading({ level: 2 })
          .run()}}},[_c('icon',{attrs:{"name":"h2"}})],1),_c('button',{class:{ 'is-active': _vm.editor.isActive('heading', { level: 3 }) },attrs:{"type":"button","title":"Heading 3"},on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .toggleHeading({ level: 3 })
          .run()}}},[_c('icon',{attrs:{"name":"h3"}})],1),_c('button',{attrs:{"type":"button","title":"Clear Formatting"},on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .unsetAllMarks()
          .run()}}},[_c('icon',{attrs:{"name":"format-clear"}})],1)]):_vm._e(),_c('editor-content',{attrs:{"editor":_vm.editor}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }